import {
  INDUSTRY_OPTIONS,
  JOB_TITLE_OPTIONS,
  REFERRAL_SOURCE_OPTIONS,
  ROLE_OPTIONS,
  SELECT_INPUT_OTHER_VALUE,
  SENIORITY_OPTIONS,
  TEAM_OPTIONS
} from "@/src/common/business-layer/constants"
import { InferType, object, string } from "yup"

const ROLE_VALUES = ROLE_OPTIONS.map((option) => option.value)
const TEAM_VALUES = TEAM_OPTIONS.map((option) => option.value)

const valuesIncluding = (values: Array<string>, saved?: string) =>
  saved && !values.includes(saved) ? [...values, saved] : values

export const createExistingUserProfileUpdateSchema = (
  savedRole?: string,
  savedTeam?: string
) =>
  object({
    firstName: string().required("First name is required"),
    lastName: string().required("Last name is required"),
    jobTitle: string()
      .required()
      .oneOf(
        valuesIncluding(ROLE_VALUES, savedRole),
        "Role must be one of the available options"
      ),
    team: string()
      .required("Team is required")
      .oneOf(
        valuesIncluding(TEAM_VALUES, savedTeam),
        "Team must be one of the available options"
      ),
    teamOther: string().when("team", {
      is: SELECT_INPUT_OTHER_VALUE,
      then: (schema) => schema.required("Please specify your team"),
      otherwise: (schema) => schema.notRequired()
    })
  })

export const ExistingUserProfileUpdateSchema =
  createExistingUserProfileUpdateSchema()

export type ExistingUserProfileUpdate = InferType<
  typeof ExistingUserProfileUpdateSchema
>

export const ProfileUpdateSchema = object({
  phoneNumber: string()
    .required()
    .matches(/[0-9]+/, { message: "${label} must be only digits" })
    .min(7, "${label} must be at least ${min} digits")
    .max(15, "${label} must be at most ${max} digits")
    .label("Phone number"),
  companyName: string().required().label("Company name"),
  companySize: string().required().label("Company size"),
  jobTitle: string()
    .required()
    .oneOf(
      JOB_TITLE_OPTIONS.map((titleOptions) => titleOptions.value),
      "${label} must be one of the available options"
    )
    .label("Job title"),
  jobTitleAlt: string()
    .when("seniority", {
      is: "Other",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Job title"),
  seniority: string()
    .required()
    .oneOf(
      SENIORITY_OPTIONS.map((titleOptions) => titleOptions.value),
      "${label} must be one of the available options"
    )
    .label("Seniority"),
  seniorityAlt: string()
    .when("seniority", {
      is: "Other",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Seniority"),
  industry: string()
    .required()
    .oneOf(
      INDUSTRY_OPTIONS.map((titleOptions) => titleOptions.value),
      "${label} must be one of the available options"
    )
    .label("Industry"),
  industryAlt: string()
    .when("industry", {
      is: "Other",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Industry"),
  city: string().required().label("City"),
  country: string().required().label("Country"),
  referralSource: string()
    .oneOf(
      REFERRAL_SOURCE_OPTIONS.map((titleOptions) => titleOptions.value),
      "${label} must be one of the available options"
    )
    .required()
    .label("Referral source"),
  referralSourceAlt: string().label("Referral source"),
  firstName: string().label("First name"),
  lastName: string().label("Last name")
})

export type ProfileUpdate = InferType<typeof ProfileUpdateSchema>
